import useDevFeaturesVisible from "hooks/useDevFeaturesVisible";

/**
 * Only show the child components to DEV users who currently have admin features
 * toggled on (header icon, EsgAdminViewToggle - shared with EsgAdminOnly). A developer
 * can hide this content without losing the role - see useDevFeaturesVisible.
 *
 * Use-case: for extra admin and debugging utilities, that could be confusing or ugly for
 * normal users.
 */
export default function DevOnly({ children, style }) {
  const showDevFeatures = useDevFeaturesVisible();
  if (showDevFeatures) {
    return (
      <div className="DevOnly" style={style}>
        {children}
      </div>
    );
  }
  return null;
}
